import { Ajv } from 'ajv';
import addFormats from 'ajv-formats';
/**
 * Singleton ajv instance configured for validation only.
 *
 * Configuration:
 * - allErrors: Collect all errors, not just first
 * - coerceTypes: false - Don't mutate input, validate as-is
 * - useDefaults: false - Don't apply defaults, form handles this via generateDefaults()
 * - strict: false - Lenient mode for schema flexibility
 */
export const ajv = new Ajv({
    allErrors: true,
    coerceTypes: false,
    useDefaults: false,
    strict: false
});
addFormats.default(ajv);
